import React from 'react';
import { Text as BaseText } from '@gasbuddy/react-components';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Text.module.css';

const cx = classnames.bind(styles);

export default function Text({ className, screenReader, ...rest }) {
  return (
    <BaseText className={cx({ screenReader }, className)} {...rest} />
  );
}

Text.propTypes = {
  className: PropTypes.string,
  screenReader: PropTypes.bool,
};

Text.defaultProps = {
  className: undefined,
  screenReader: false,
};
